import nmosShape from "../../js/nmosShape";
import pmosShape from '../../js/pmosShape';
// import nmos4Shape from "../../js/nmos4Shape";
// import pmos4Shape from "../../js/pmos4Shape";
import outputPinShape from "../../js/outputPinShape";
import inputPinShape from "../../js/inputPinShape";
import inputOutputPinShape from "../../js/inputOutputPinShape";
import nmosStickShape from "../../js/nmosStickShape";
import pmosStickShape from "../../js/pmosStickShape";
import symbolShape from "../../js/symbolShape";
import { mxCellRenderer } from "./mxModule";
import noConnectionShape from "../../js/noConnectionShape";

/**
 * Maps shape names to their static config (width, height, ports).
 * Add a new entry here whenever a new shape with ports is introduced.
 * The config itself lives in the shape file (e.g. nmosShape.config).
 */
export const shapeConfigRegistry = {
    nmos: nmosShape.config,
    pmos: pmosShape.config,
    "no-conn": noConnectionShape.config, 
};

// Separate registry for StickDiagram — nmos/pmos map to their stick variants
export const stickShapeConfigRegistry = {
    nmos: nmosStickShape.config,
    pmos: pmosStickShape.config,
    "no-conn": noConnectionShape.config, 
};

function registerPins() {
    mxCellRenderer.registerShape("in", inputPinShape);
    mxCellRenderer.registerShape("out", outputPinShape);
    mxCellRenderer.registerShape("inout", inputOutputPinShape);
}

function registerCustomShapes() {
    mxCellRenderer.registerShape("pmos", pmosShape);
    mxCellRenderer.registerShape("nmos", nmosShape);
    mxCellRenderer.registerShape("no-conn", noConnectionShape);

    // mxCellRenderer.registerShape("pmos4", pmos4Shape);
    // mxCellRenderer.registerShape("nmos4", nmos4Shape);

    mxCellRenderer.registerShape("symbol", symbolShape);
    registerPins();
}

function registerCustomShapesForStick() {
    mxCellRenderer.registerShape("nmos", nmosStickShape);
    mxCellRenderer.registerShape("pmos", pmosStickShape);
    mxCellRenderer.registerShape("no-conn", noConnectionShape);
    registerPins();
}

export { registerCustomShapes, registerCustomShapesForStick }